module.exports = __webpack_public_path__ + "static/img/ninja-can-03.0baa44f3.png";